import AlignButtons from "pages/report-constructor/align-buttons/align-buttons";
import React, {useState, useEffect } from "react";
import FontBase from "../font-base/font-base";

const Period = (props) => {
    const [parameters, setParameters] = useState(props.parameters ? props.parameters : null);
    const [isReadOnly, setIsReadOnly] = useState(props.isReadOnly);

    useEffect(() => {
        setParameters(props.parameters ? props.parameters : null);
        setIsReadOnly(props.isReadOnly);
    }, [props]);

    const removeParameter = () => {
        props.removeParameter(props.index, 'FONT_PARAMETERS');
    }

    const addParameter = () => {
        props.addParameter(props.index, 'FONT_PARAMETERS');
    }

    const updateParameters = (type, parameter, value) => {
        let params = {...parameters};
        if(parameter){
            let fontParams = {...params[type]}
            fontParams[parameter] = value;
            params[type] = fontParams
        }
        else
            params[type] = value;
        if(value === ''){
            delete params[type][parameter];
        }
        props.updateComponent(props.index, params);
        //setRerender(!rerender)
    }

    const align = (align) => {
        let params = {...parameters};
        params.ALIGNMENT = align;
        props.updateComponent(props.index, params);
    }

    return (
        <div>
            <AlignButtons alignItems={align} getValue={props.getValue} alignment={parameters.ALIGNMENT ? parameters.ALIGNMENT : null}/>
            <FontBase 
                        readOnly={isReadOnly} 
                        getValue={props.getValue} 
                        fonts={props.fonts} colors={props.colors} 
                        parameters={parameters.FONT_PARAMETERS} 
                        updateParameters={updateParameters} 
                        type={'FONT_PARAMETERS'}
                        removeParameter={removeParameter} 
                        addParameter={addParameter}
            />
        </div>
        
    )
}

export default Period;